import React from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import { useQueryParamLang, useLanguage, useMe } from '../../../hooks'
import { setSize } from '../../../style'
import Text from '../../../components/common/Text'
import Block from '../../../components/common/Block'
import Spacer from '../../../components/common/Spacer'
import SplitFlapDisplay from '../../../components/common/SplitFlapDisplay'
import Globe from '../../../components/forest/globe'

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #ffffff;
`

const ForestWidget = () => {

    const { puid, offset = 0 } = useParams()
    const { lang } = useQueryParamLang()
    const { t } = useLanguage(lang)

    const [loadingInfo, error, medalInfo] = useMe({ puid })

    if (loadingInfo) {
        return (
            // TODO: add a nice loading component to be reused across widgets
            <Block alignItems="center">
                <Text>{t('loadingComp.title')}</Text>
            </Block>
        )
    }

    if (error || medalInfo == null) {
        return null
    }

    const {
        treesPlantedTribe,
    } = medalInfo || {}

    const totalTrees = treesPlantedTribe + parseInt(offset, 10)

    return (
        <MainContainer>
            <Text uppercase size="L" center>
                {t('vitaminWellForest.openTitle.title')}
            </Text>
            <Spacer size="XL" />

            <Globe
                imageName={totalTrees > 30 ? 'globeWithTrees@2x.png' : 'globeEmpty@2x.png'}
                trees={Math.min(totalTrees, 15)}
                alignSelf="center"
            />
            <Spacer size="XL" />

            <SplitFlapDisplay
                number={totalTrees}
                length={6}
                size={setSize('S', 'XS')}
                alignSelf="center"
            />
            <Spacer size="L" />
            <Text center>
                {t('vitaminWellForest.counter.title')}
            </Text>
        </MainContainer>
    )
}

export default ForestWidget
